"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { getLocationProvidersInstructions, type LocationProvidersInstructionsResult } from "@/src/requests/location-providers-instructions";
export function useLocationProvidersInstructions(locationId) {
  const $ = _c(2);
  let t0;
  if ($[0] !== locationId) {
    t0 = {
      queryKey: ["location-providers-instructions", locationId],
      queryFn: () => getLocationProvidersInstructions(locationId),
      staleTime: 300000
    };
    $[0] = locationId;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return useQuery(t0);
}